// extracted by mini-css-extract-plugin
export default {"container":"I0-z","list":"J0-z"};